export const DELIVERY_AND_RETURNS_DATA_SOURCES = {
  checkout: 'checkout',
  cart: 'cart',
}
